import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

import { Translator as TranslatorComponent } from 'ggApp/modules/translator/components';
import useOverrides, { OverridesPropType } from 'ggApp/shared/hooks/useOverrides';

import { Container, Headline, CardContent } from './Card.styles';

const STATIC_CARD_HEIGHT_IN_PX = 320;

const defaultComponents = {
    Translator: TranslatorComponent,
};

const SubscriptionActionsCard = ({
    className,
    headline,
    hasError,
    loading,
    onContactButtonClick,
    children,
    overrides,
    elevated,
}) => {
    const {
        Translator: { component: Translator },
    } = useOverrides(defaultComponents, overrides);

    return (
        <Container
            className={className}
            elevated={elevated}
            hasError={hasError}
            loading={loading}
            errorTitle={<Translator tk="SUBSCRIPTION_CARD_ERROR_SCREEN_TITLE_ACTIONS" />}
            errorMessage={<Translator tk="SUBSCRIPTION_CARD_ERROR_SCREEN_MESSAGE" />}
            contactButtonText={<Translator tk="SUBSCRIPTION_CARD_ERROR_SCREEN_CONTACT_BUTTON" />}
            onContactButtonClick={onContactButtonClick}
            staticHeight={STATIC_CARD_HEIGHT_IN_PX}
            overrides={{
                Content: { component: CardContent },
                ...overrides,
            }}
        >
            {headline && <Headline>{headline}</Headline>}
            {Children.toArray(children).map((action, index, actions) =>
                cloneElement(action, {
                    withDelimiter: index < actions.length - 1,
                }),
            )}
        </Container>
    );
};

SubscriptionActionsCard.propTypes = {
    elevated: PropTypes.bool,
    children: PropTypes.node,
    headline: PropTypes.string,
    className: PropTypes.string,
    hasError: PropTypes.bool,
    loading: PropTypes.bool,
    overrides: OverridesPropType,
    onContactButtonClick: PropTypes.func.isRequired,
};

SubscriptionActionsCard.defaultProps = {
    headline: '',
    className: '',
    hasError: false,
    loading: false,
    children: null,
    overrides: {},
    elevated: false,
};

export default SubscriptionActionsCard;
